export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left: Quote */}
          <div className="lg:w-3/5">
            <p className="text-xs tracking-widest uppercase text-foreground-400 font-label mb-4">
              &bull; Customer Review
            </p>
            <blockquote className="text-xl md:text-2xl lg:text-3xl font-heading text-foreground-900 leading-relaxed mb-6">
              &#8220;The GTBuy Spreadsheet system completely transformed how I manage my product sourcing. The automation features and real-time data sync have saved me countless hours every week.&#8221;
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-800">Sarah Mitchell</span>
              <span className="flex items-center gap-0.5 text-accent-500">
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
                <i className="ri-star-fill text-sm"></i>
              </span>
              <span className="text-xs text-foreground-400">Verified Buyer</span>
            </div>
          </div>

          {/* Right: Image */}
          <div className="lg:w-2/5">
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20workspace%20with%20laptop%20and%20fashion%20accessories%20on%20minimal%20desk%2C%20warm%20natural%20lighting%20from%20window%2C%20clean%20modern%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20professional%20lifestyle%20photography%2C%20architectural%20interior%20with%20greenery%2C%20editorial%20quality&width=700&height=933&seq=testimonial-img-01&orientation=portrait"
                alt="Workspace testimonial"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}